import fvSubassembly from '../fvSubassembly';
// import Vue from 'vue'
// import { Color } from 'fabric/fabric-impl'
export default class fvPipeObj extends fvSubassembly {
    constructor (sContent, parent, system, callback) {
        super(sContent, parent, system);
        this.initPoints = JSON.parse(JSON.stringify(this.points));
        //用于流动属性 不勾选“只有流动时才显示”时使用
        this.create();
        if (this.isDelayedWaiting) {
            this.complete = callback;
        } else {
            callback(this);
        }
        this.pathData = this.getPipeData();
        // 过滤id
        this.filterID = this.uuid();
        //创建图元
        //添加折线
        this.pipeDom = document.createElementNS('http://www.w3.org/2000/svg', 'g');
        
        // 流动dom
        this.flowDom = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        this.pipeDom.appendChild(this.flowDom);
        system.appendChild(this.pipeDom);
        this.createSucss(this.pipeDom, sContent);
        // 创建样式
        this.parent = parent;
        this.createStyle();

    }

    createStyle () {
        this.setPosition();
        this.pipeDom.innerHTML="";
        // 添加光照
        this.pipeDom.innerHTML += this.setLight();
        // 添加管道dom
        this.pathData.forEach(item => {
            this.pipeDom.innerHTML += ` <path d="M${item.path_d}" fill="none" stroke="${item.path_stroke}" stroke-width="${item.path_strokeWidth}" />`;
        });
        this.pipeDom.style.filter = `url(#${this.filterID})`;
        this.setCorner(this.pipeDom, this.cornerMode);
        this.pipeDom.style.width = this.width + "px";
        this.pipeDom.style.height = this.height + "px";
        // 流动属性
        // this.flowDom.setAttribute('d', 'M' + this.points);
        this.flowDom.style.fill = 'none';
        this.flowDom.style.stroke = 'none';
    }

    // 显示隐藏
    isShow (value) {
        value ? this.pipeDom.style.display = 'block' : this.pipeDom.style.display = 'none';
        value ? this.flowDom.style.display = 'block' : this.flowDom.style.display = 'none';
    }
    // 设置位置
    setPosition() {
        for (let i = 0; i < this.points.length; i++) {
            let points0 = this.initPoints[i][0] + this.initPoints[i][0] * this.frameScaleX;
            let points1 = this.initPoints[i][1] + this.initPoints[i][1] * this.frameScaleY;
            this.points[i][0] = (points0 * this.magnification.x + this.cx - this.parent.parentX - this.borderWidth / 2);
            this.points[i][1] = (points1 * this.magnification.y + this.cy - this.parent.parentY - this.borderWidth / 2);
        }
        this.flowDom.setAttribute('d', 'M' + this.points);
    }
    init () {
        super.init();
        // 根据x y 因边框、缩放改变导致绘制多折线重新计算
        for (let i = 0; i < this.points.length; i++) {
            let points0 = this.initPoints[i][0] + this.initPoints[i][0] * this.frameScaleX;
            let points1 = this.initPoints[i][1] + this.initPoints[i][1] * this.frameScaleY;
            this.points[i][0] = (points0 * this.magnification.x + this.cx - this.parent.parentX - this.borderWidth / 2);
            this.points[i][1] = (points1 * this.magnification.y + this.cy - this.parent.parentY - this.borderWidth / 2);
        }
    }

    onDraw () {
        //调用动画 完成动画 更改实时样式
        this.executePreAnimation(this.pipeDom);
        this.pipeDom.style.transform = `translate(${this.translateX + 'px'}, ${this.translateY + 'px'}) rotate(${this.rotating + 'deg'}`;
        this.pipeDom.style.transformOrigin = `${this.originPinitX + 'px'}  ${this.originPinitY + 'px'}`;
    }

    // 设置拐角
    setCorner (dom, corner) {
        switch (corner) {
            case 'rr':// 圆头圆拐角
                dom.setAttribute('stroke-linecap', 'round');
                dom.setAttribute('stroke-linejoin', 'round');
                break;

            case 'rs':// 圆头方拐角
                dom.setAttribute('stroke-linecap', 'round');
                dom.setAttribute('stroke-linejoin', 'miter');
                break;

            case 'sr':// 方头圆拐角
                dom.setAttribute('stroke-linecap', 'square');
                dom.setAttribute('stroke-linejoin', 'round');
                break;

            case 'ss':// 方头方拐角
                dom.setAttribute('stroke-linecap', 'square');
                dom.setAttribute('stroke-linejoin', 'miter');
                break;
            default:
                break;
        }
    }

    // 设置拐角大小
    setCornerSize() {
        // 暂不支持
    }
    // 设置光照
    setLight () {
        let dx = '',
            dy = '';
        switch (this.lightMode) {
            case 'middle': // 正中
                dx = '0';
                dy = '0';
                break;
            case 'left': // 左侧
                dx = '5';
                dy = '0';
                break;
            case 'leftTop': // 左上
                dx = '5';
                dy = '5';
                break;
            case 'leftBottom': // 左下
                dx = '5';
                dy = '-5';
                break;
            case 'top': // 上
                dx = '0';
                dy = '5';
                break;
            case 'bottom': // 下
                dx = '0';
                dy = '-0';
                break;
            case 'right': // 右侧
                dx = '-5';
                dy = '0';
                break;
            case 'rightTop': // 右上
                dx = '-5';
                dy = '5';
                break;
            case 'rightBottom': // 右下
                dx = '-5';
                dy = '-5';
                break;
            default:
                break;
        }
        return `<defs>
                    <filter id="${this.filterID}" filterUnits="userSpaceOnUse">
                        <feGaussianBlur in="SourceAlpha" stdDeviation="4" result="blur" />
                        <feoffset in="blur" dx="${dx}" dy="${dy}" result="offsetBlur" />
                        <feMerge>
                            <feMergeNode in="offsetBlur" />
                            <feMergeNode in="SourceGraphic" />
                        </feMerge>
                    </filter>
                </defs>`;
    }

    // 获取管道数据
    getPipeData () {
        let pathData = [];
        let {r, g, b} = this.getRgb(this.outsideColor);
        let r1 = Math.min(255, (r + (255 + r) / 8 + r / 2));
        let g1 = Math.min(255, (g + (255 + g) / 8 + g / 2));
        let b1 = Math.min(255, (b + (255 + b) / 8 + b / 2));
        r /= 2;
        g /= 2;
        b /= 2;
        let addR = (r1 - r) / this.borderWidth;
        let addG = (g1 - g) / this.borderWidth;
        let addB = (b1 - b) / this.borderWidth;
        let addWidthStep = this.borderWidth < 8 ? 2.0 : 2.0 * this.borderWidth / 32.0 + 2.0;
        // 判断是否为一种颜色
        if (this.colorStyle == 1) {
            for (let index = 0; index < this.borderWidth; index += addWidthStep) {
                pathData.push({
                    path_d: this.points,
                    path_strokeWidth: this.borderWidth + 1 - index,
                    // path_stroke: `rgb(r: ${parseInt(r + addR * index)},g: ${parseInt(g + addG * index)},b:${parseInt(b + addB * index)} )`
                    path_stroke: `rgb(${r + addR * index},${g + addG * index},${b + addB * index})`
                });
            }
        } else {
            let gradientColorArr = this.twoColorGradient(this.outsideColor, this.insideColor, this.borderWidth / addWidthStep);
            let step = 0;
            for (let index = 0; index < this.borderWidth; index += addWidthStep) {
                pathData.push({
                    path_d: this.points,
                    path_strokeWidth: this.borderWidth + 1 - index,
                    // path_stroke: `rgb(r: ${parseInt(r + addR * index)},g: ${parseInt(g + addG * index)},b:${parseInt(b + addB * index)} )`
                    path_stroke: gradientColorArr[step] ? gradientColorArr[step] : gradientColorArr[gradientColorArr.length - 1]
                });
                step++;
            }
        }
        return pathData;
    }

    // 获取rgb的值
    getRgb (hex) {
        return {
            r: parseInt('0x' + hex.slice(1, 3)),
            g: parseInt('0x' + hex.slice(3, 5)),
            b: parseInt('0x' + hex.slice(5, 7))
        };
    }

    hexToRgb (hex) {
        let rgb = [];
        for (let i = 1; i < 7; i += 2) {
            rgb.push(parseInt('0x' + hex.slice(i, i + 2)));
        }
        return rgb;
    }

    rgbToHex (r, g, b) {
        let hex = ((r << 16) | (g << 8) | b).toString(16);
        return '#' + new Array(Math.abs(hex.length - 7)).join('0') + hex;
    }

    // 计算两种颜色的渐变
    twoColorGradient (startColor, endColor, step) {
        //将hex转换为rgb
        let sColor = this.hexToRgb(startColor),
            eColor = this.hexToRgb(endColor);

        //计算R\G\B每一步的差值
        let rStep = (eColor[0] - sColor[0]) / step;
        let gStep = (eColor[1] - sColor[1]) / step;
        let bStep = (eColor[2] - sColor[2]) / step;

        let gradientColorArr = [];
        for (let i = 0; i < step; i++) {
            //计算每一步的hex值
            gradientColorArr.push(this.rgbToHex(parseInt(rStep * i + sColor[0]), parseInt(gStep * i + sColor[1]), parseInt(bStep * i + sColor[2])));
        }
        return gradientColorArr;
    }
}



// WEBPACK FOOTER //
// ./src/js/div/divUnit/fvPipeObj.js